import React from 'react'
import { Menu } from '@headlessui/react'
import { HiDotsVertical } from 'react-icons/hi'

const MessageMenuOption = ({
  message,
  channel,
  userType,
  onForward,
  onAssign,
  onDelete,
  onSendNow
}) => {
  return (
    <div className={`relative ${userType === 'sender' ? 'self-end' : ''}`}>
      <Menu as='div' className='inline-block text-left pb-2'>
        <Menu.Button>
          <HiDotsVertical />
        </Menu.Button>

        <Menu.Items
          className={`absolute z-10 w-fit mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none
          ${userType === 'sender' ? 'right-[25px] top-[-30px]' : 'left-10 top-[-25px]'}`}
        >
          <div className='px-1 py-1 flex flex-col'>
            {!message._scheduledStatus && message?.messageType !== 'file' && (
              <Menu.Item>
                {({ active }) => (
                  <p
                    className={`${active && 'text-everglade-700 cursor-pointer'} p-2`}
                    onClick={() => onForward?.(message)}
                  >
                    Forward
                  </p>
                )}
              </Menu.Item>
            )}

            {!message._scheduledStatus &&
              message?.sender &&
              message?.sender?.userId !== '' &&
              channel?.customType === 'DPCDoctor' && (
                <Menu.Item>
                  {({ active }) => (
                    <p
                      className={`${active && 'text-everglade-700 cursor-pointer'} p-2`}
                      onClick={() => onAssign?.(message)}
                    >
                      Assign
                    </p>
                  )}
                </Menu.Item>
              )}

            {userType === 'sender' && (
              <Menu.Item>
                {({ active }) => (
                  <p
                    className={`${active && 'text-everglade-700 cursor-pointer'} p-2`}
                    onClick={() => onDelete?.(message)}
                  >
                    Delete
                  </p>
                )}
              </Menu.Item>
            )}

            {message._scheduledStatus && (
              <Menu.Item>
                {({ active }) => (
                  <p
                    className={`${active && 'text-everglade-700 cursor-pointer'} p-2`}
                    onClick={() => onSendNow?.(message)}
                  >
                    Send<span className='pl-1'>now</span>
                  </p>
                )}
              </Menu.Item>
            )}
          </div>
        </Menu.Items>
      </Menu>

    </div>
  )
}

export default MessageMenuOption